import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Lazy chunks rejected after deploy — Error Boundary may not see promise rejections
window.addEventListener('unhandledrejection', (event) => {
  const r = event.reason;
  const name = r && r.name;
  const msg = String((r && r.message) || r || '');
  if (
    name === 'ChunkLoadError' ||
    /loading chunk [\d]+ failed/i.test(msg) ||
    /Failed to fetch dynamically imported module/i.test(msg)
  ) {
    event.preventDefault();
    window.location.reload();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// PWA: register the service worker for offline support.
// We do this in production only so local development stays fast.
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register(`${process.env.PUBLIC_URL}/service-worker.js`)
      .catch((err) => {
        // Registration failures shouldn't break the app.
        console.warn('Service worker registration failed:', err);
      });
  });
}
